const storage = window.localStorage;

export enum GlobalStorageKeys {
  CacheBusterKey = 'latest_commit_sha1',
  DismissedBanners = 'dismissed_banners',
  ShippersDashboardDemurrageBreakdown = 'shippers_dashboard_demurrage_breakdown',
  ShippersDashboardPerDiemBreakdown = 'shippers_dashboard_per_diem_breakdown',
}

export const LocalStorageUtil = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(storageItemName: GlobalStorageKeys | string, value: any) {
    const stringifiedValue = JSON.stringify(value);
    storage.setItem(storageItemName, stringifiedValue);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T = any>(storageItemName: GlobalStorageKeys | string): T | null {
    const storageItemValue = storage.getItem(storageItemName);

    if (storageItemValue == null) {
      return null;
    }

    try {
      return JSON.parse(storageItemValue);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  },

  remove(storageItemName: string) {
    storage.removeItem(storageItemName);
  },
};

export const bustCache = async () => {
  const localCommit = LocalStorageUtil.get(GlobalStorageKeys.CacheBusterKey);
  const meta = await (await fetch('/meta.json')).json();
  const currentCommit = meta.latest_commit_sha1;

  if (localCommit !== currentCommit) {
    LocalStorageUtil.set(GlobalStorageKeys.CacheBusterKey, currentCommit);
    window.location.reload();
  }
};
